import { Types } from './types';

export const
    appRoot = '#es-form-app',
    pluginBasePath = '/wp-content/plugins/es-forms',
    baseURL = process.env.NODE_ENV === 'development' ? 'https://crossorigin.me/https://energetickesluzby.sk/' : '/',
    authNonce = process.env?.NODE_ENV === 'development' ? 'WOOPTIMA_DEV': document.querySelector(appRoot)?.getAttribute('data-nonce'),
    endpoints: Types.API_Endpoints = {
        getFormSections: {
            method: 'GET',
            url: '/form',
        },
        getCitiesList: {
            method: 'GET',
            url: '/cities',
        },
        submitForm: {
            method: 'POST',
            url: '/submit',
            data: {},
        }
    };